import React, { useEffect, useRef, useState } from "react";
import { FaVideo } from "react-icons/fa";
import endpoints from "../../utility/endpoints";
import { CustomVideo } from "../shared/PlayIcon";
import { RxCross2 } from "react-icons/rx";

const CRDemo = () => {
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef();
  const videoUrl =
    "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/instructionvideos/Change_Request.mp4?" +
    process.env.NEXT_PUBLIC_SAS_TOKEN;

  useEffect(() => {
    if (showVideo) {
      videoRef.current?.play();
    } else {
      videoRef.current?.pause();
    }
  }, [showVideo]);

  const closeVideo = (e) => {
    e.stopPropagation();
    setShowVideo(false);
  };

  return (
    <>
      <span
        onClick={() => setShowVideo(true)}
        className="flex px-3 py-2 animate-pulse items-center justify-center gap-2 h-full !border !border-purple-600 text-purple-600 cursor-pointer"
      >
        <FaVideo /> CR Demo Video
      </span>
      {showVideo && (
        <div className="z-[9999] fixed left-0 top-0 w-screen h-screen bg-[rgba(0,0,0,0.2)] flex justify-center items-center">
          <div className="h-[85%] relative">
            <div
              onClick={closeVideo}
              className="w-8 h-8 flex justify-center items-center bg-red-500 absolute z-[99999] right-0 top-0 !cursor-pointer"
            >
              <RxCross2 className="text-white w-5 h-5" />
            </div>
            <CustomVideo
              ref={videoRef}
              src={videoUrl}
              controls
              className="!w-full !h-full"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CRDemo;

